import { render, staticRenderFns } from "./ProProfileCPage.vue?vue&type=template&id=508a3362"
import script from "./ProProfileCPage.vue?vue&type=script&lang=js"
export * from "./ProProfileCPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports